/* Baby Jogger NZ bundle builder */
(function () {
  'use strict';

  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    var value = '';
    var placeholder = /\{\{\s*(\w+)\s*\}\}/;
    format = format || '${{amount}}';
    function withDelimiters(number, precision, thousands, decimal) {
      precision = precision == null ? 2 : precision;
      thousands = thousands || ',';
      decimal = decimal || '.';
      if (isNaN(number) || number == null) return 0;
      number = (number / 100.0).toFixed(precision);
      var parts = number.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var centsPart = parts[1] ? decimal + parts[1] : '';
      return dollars + centsPart;
    }
    var match = format.match(placeholder);
    switch (match ? match[1] : 'amount') {
      case 'amount_no_decimals': value = withDelimiters(cents, 0); break;
      case 'amount_with_comma_separator': value = withDelimiters(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = withDelimiters(cents, 0, '.', ','); break;
      default: value = withDelimiters(cents, 2);
    }
    return format.replace(placeholder, value);
  }

  function decode(str) {
    var t = document.createElement('textarea');
    t.innerHTML = str;
    return t.value;
  }

  function joinOr(list) {
    if (list.length <= 1) return list.join('');
    return list.slice(0, -1).join(', ') + ' or ' + list[list.length - 1];
  }

  function refreshCartBubble() {
    return fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('.cart-link__bubble').forEach(function (b) {
          b.classList.toggle('cart-link__bubble--visible', cart.item_count > 0);
        });
        return cart;
      })
      .catch(function () {});
  }

  function addItems(items) {
    return fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) {
      return r.json().then(function (data) {
        if (!r.ok) {
          var msg = (data && (data.description || data.message)) || 'Sorry, something went wrong. Please try again.';
          throw new Error(msg);
        }
        return data;
      });
    });
  }

  function announceAdded(data, btn) {
    var product = data && data.items ? data.items[data.items.length - 1] : data;
    try {
      document.dispatchEvent(new CustomEvent('ajaxProduct:added', { detail: { product: product, addToCartBtn: btn } }));
    } catch (e) {}
    return refreshCartBubble();
  }

  function readInput(input) {
    if (!input || !input.value) return null;
    return {
      id: parseInt(input.value, 10),
      price: parseInt(input.getAttribute('data-price'), 10) || 0,
      title: decode(input.getAttribute('data-title') || '')
    };
  }

  function Builder(el) {
    this.el = el;
    this.format = decode(el.getAttribute('data-money-format') || '${{amount}}');
    this.tierOne = parseFloat(el.getAttribute('data-tier-one')) || 0;
    this.tierTwo = parseFloat(el.getAttribute('data-tier-two')) || 0;
    this.cartUrl = el.getAttribute('data-cart-url') || '/cart';
    this.adaptor = el.querySelector('input[data-role="adaptor"]');
    this.lines = el.querySelector('[data-lines]');
    this.totals = el.querySelectorAll('[data-total]');
    this.savingRow = el.querySelector('[data-saving-row]');
    this.saving = el.querySelector('[data-saving]');
    this.savingLabel = el.querySelector('[data-saving-label]');
    this.nudge = el.querySelector('[data-nudge]');
    this.msg = el.querySelector('[data-msg]');
    this.buttons = el.querySelectorAll('[data-add-bundle]');

    // Each optional add-on step (capsule, bassinet, second seat...)
    this.steps = [];
    var self = this;
    el.querySelectorAll('[data-addon-step]').forEach(function (fs) {
      var name = fs.getAttribute('data-addon-name');
      self.steps.push({
        name: name,
        label: fs.getAttribute('data-addon-label'),
        isCapsule: fs.hasAttribute('data-capsule-step'),
        available: !!fs.querySelector('input[name="' + name + '"]:not([value=""]):not(:disabled)')
      });
    });

    el.addEventListener('change', function (e) {
      if (e.target && e.target.classList.contains('bb-option__input')) self.update();
    });
    this.buttons.forEach(function (b) {
      b.addEventListener('click', function () { self.addBundle(b); });
    });
    el.querySelectorAll('[data-add-extra]').forEach(function (b) {
      b.addEventListener('click', function () { self.addExtra(b); });
    });
    this.update();
  }

  Builder.prototype.selection = function () {
    var el = this.el;
    var stroller = readInput(el.querySelector('input[name="bb-stroller"]:checked'));
    var addons = [];
    var adaptorNeeded = false;
    this.steps.forEach(function (step) {
      var item = readInput(el.querySelector('input[name="' + step.name + '"]:checked'));
      if (item) {
        item.label = step.label;
        addons.push(item);
        if (step.isCapsule) adaptorNeeded = true;
      }
    });
    var adaptor = null;
    if (adaptorNeeded && this.adaptor && this.adaptor.value) {
      adaptor = readInput(this.adaptor);
      adaptor.available = this.adaptor.getAttribute('data-available') === 'true';
    }
    return { stroller: stroller, addons: addons, adaptor: adaptor };
  };

  Builder.prototype.update = function () {
    var s = this.selection();
    var fmt = this.format;
    var esc = function (t) { return t.replace(/&/g, '&amp;').replace(/</g, '&lt;'); };
    var line = function (item) {
      return '<li class="bb-summary__line"><span>' + esc(item.title) + '</span><span>' + formatMoney(item.price, fmt) + '</span></li>';
    };

    var html = '';
    var eligible = 0;
    var full = 0;
    if (s.stroller) {
      html += line(s.stroller);
      eligible += s.stroller.price;
      full += s.stroller.price;
      s.addons.forEach(function (a) {
        html += line(a);
        eligible += a.price;
        full += a.price;
      });
      if (s.adaptor) {
        html += line(s.adaptor);
        full += s.adaptor.price;
      }
    } else {
      html = '<li class="bb-summary__line bb-summary__line--empty">Choose a stroller to start your bundle.</li>';
    }
    this.lines.innerHTML = html;

    var count = s.addons.length;
    var pct = 0;
    if (s.stroller && count >= 2) pct = this.tierTwo;
    else if (s.stroller && count === 1) pct = this.tierOne;
    var saving = Math.round(eligible * pct / 100);
    var total = full - saving;

    if (pct > 0) {
      this.savingRow.hidden = false;
      this.savingLabel.textContent = 'Bundle saving (' + pct + '%)';
      this.saving.textContent = '-' + formatMoney(saving, fmt);
    } else {
      this.savingRow.hidden = true;
    }
    this.totals.forEach(function (t) { t.textContent = s.stroller ? formatMoney(total, fmt) : ''; });

    // Friendly nudge towards the next saving tier
    var picked = s.addons.map(function (a) { return a.label; });
    var open = this.steps.filter(function (st) { return st.available && picked.indexOf(st.label) === -1; })
      .map(function (st) { return st.label; });
    var nudge = '';
    if (s.stroller) {
      if (count === 0 && open.length > 1) {
        nudge = 'Add a ' + joinOr(open) + ' to save ' + this.tierOne + '%, or add two to save ' + this.tierTwo + '%.';
      } else if (count === 0 && open.length === 1) {
        nudge = 'Add the ' + open[0] + ' to save ' + this.tierOne + '% on your bundle.';
      } else if (count === 1 && open.length > 0) {
        nudge = 'Add a ' + joinOr(open) + ' too and save ' + this.tierTwo + '% on your bundle.';
      } else if (count >= 2) {
        nudge = 'You are saving ' + this.tierTwo + '% on your bundle.';
      } else if (count === 1) {
        nudge = 'You are saving ' + this.tierOne + '% on your bundle.';
      }
    }
    this.nudge.textContent = nudge;
    this.nudge.hidden = !nudge;

    var disabled = !s.stroller;
    this.buttons.forEach(function (b) { b.disabled = disabled; });
    this.msg.hidden = true;
  };

  Builder.prototype.addBundle = function (btn) {
    var s = this.selection();
    if (!s.stroller) return;
    if (s.adaptor && !s.adaptor.available) {
      this.showMsg('The capsule adaptors for this stroller are out of stock right now, so we cannot add the capsule as a bundle. Please contact us and we will help.', true);
      return;
    }
    var items = [{ id: s.stroller.id, quantity: 1 }];
    s.addons.forEach(function (a) { items.push({ id: a.id, quantity: 1 }); });
    if (s.adaptor) items.push({ id: s.adaptor.id, quantity: 1 });

    var self = this;
    var labels = [];
    this.buttons.forEach(function (b) { labels.push(b.textContent); b.disabled = true; b.textContent = 'Adding...'; });
    addItems(items)
      .then(function (data) {
        return announceAdded(data, btn).then(function () {
          self.showMsg('Added to your cart. <a href="' + self.cartUrl + '">View cart</a>', false);
        });
      })
      .catch(function (err) { self.showMsg(err.message, true); })
      .then(function () {
        self.buttons.forEach(function (b, i) { b.disabled = false; b.textContent = labels[i]; });
      });
  };

  Builder.prototype.addExtra = function (btn) {
    var id = parseInt(btn.getAttribute('data-add-extra'), 10);
    var label = btn.textContent;
    btn.disabled = true;
    btn.textContent = 'Adding...';
    addItems([{ id: id, quantity: 1 }])
      .then(function (data) { return announceAdded(data, btn); })
      .then(function () { btn.textContent = 'Added'; })
      .catch(function () { btn.textContent = 'Sold out'; })
      .then(function () {
        setTimeout(function () { btn.disabled = false; btn.textContent = label; }, 2500);
      });
  };

  Builder.prototype.showMsg = function (html, isError) {
    this.msg.innerHTML = html;
    this.msg.classList.toggle('bb-summary__msg--error', !!isError);
    this.msg.hidden = false;
  };

  function init() {
    document.querySelectorAll('[data-bundle-builder]').forEach(function (el) {
      if (!el.__bundleBuilder) el.__bundleBuilder = new Builder(el);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
